import videos from "../assets/projectImg/videos.png";

import deja from "../assets/projectImg/deja-img.png"
import contact from "../assets/projectImg/fullStack-Python.png"

export const data = [
  {
    id: 1,
    name: "DEJA Review - Team project",
    image: deja,
    Technology: "React.js - CSS - Node - Express.js - SQL - Auth0 - Supabase - Tailwind CSS",
    github: "https://github.com/Abubakar-Meigag/FinalProject-DejaReview-teamUnity-Ldn10",
    live: "https://fp-deja-review-frontend.onrender.com/",
  },
  {
    id: 1,
    name: "Beko Videos - Full Stack app",
    image: videos,
    Technology: "React.js - CSS - Node.js - Express.js - PostgreSQL",
    github: "https://github.com/Abubakar-Meigag/Full-Stack-Project-Assessment",
    live: "https://beko-full-stack-project-assessment.onrender.com/",
  },
  {
    id: 1,
    name: "Contact-Manager - Full Stack",
    image: contact,
    Technology: "React.js - CSS - Python (Flask) - PostgreSQL",
    github: "https://github.com/Abubakar-Meigag/Contact-Manager",
    live: "https://contact-manager-blond.vercel.app/",
  },
];


